import { YOUTUBE_VIDEOS_URL } from 'utils/constants';

export interface YoutubeVideoDetails {
  title: string | null;
  description: string | null;
  viewers: number | null;
}

export const EMPTY_DETAILS: YoutubeVideoDetails = {
  title: null,
  description: null,
  viewers: null,
};

export async function getYoutubeVideoDetails(
  videoId: string
): Promise<YoutubeVideoDetails> {
  const apiKey = process.env.YOUTUBE_API_KEY;
  if (!apiKey) {
    console.error('getYoutubeVideoDetails: YOUTUBE_API_KEY is not configured');
    return EMPTY_DETAILS;
  }

  try {
    const url = new URL(YOUTUBE_VIDEOS_URL);
    url.searchParams.set('part', 'snippet,liveStreamingDetails');
    url.searchParams.set('id', videoId);
    url.searchParams.set('key', apiKey);

    const response = await fetch(url.toString());
    if (!response.ok) {
      console.error(
        `getYoutubeVideoDetails: request failed with status ${response.status}`
      );
      return EMPTY_DETAILS;
    }

    const data = await response.json();
    const item = data.items?.[0];
    const concurrentViewers = item?.liveStreamingDetails?.concurrentViewers;

    return {
      title: item?.snippet?.title ?? null,
      description: item?.snippet?.description ?? null,
      viewers:
        concurrentViewers === undefined ? null : Number(concurrentViewers),
    };
  } catch (error) {
    console.error(
      'getYoutubeVideoDetails: failed to fetch video details',
      error
    );
    return EMPTY_DETAILS;
  }
}

export default getYoutubeVideoDetails;
